import dayjs from "dayjs"
import updateLocale from 'dayjs/plugin/updateLocale'
import bg from "antd/lib/locale/bg_BG"
import en from "antd/lib/locale/en_US"
import es from "antd/lib/locale/es_ES"
import defaultSettings from '@resources/defaultSettings';
import dayjs_bg from "dayjs/locale/bg"
import dayjs_es from "dayjs/locale/es"

dayjs.extend(updateLocale)

const antLangPackagesMap: {[key: string]: any} = {
    "en" : en,
    "bg" : bg,
    "es" : es
}
const dayjsLangPackagesMap: {[key: string]: any} = {
    "bg" : dayjs_bg,
    "es" : dayjs_es
}

const initdayjs = (lang: string) => {
    if (lang !== defaultSettings.lang && dayjsLangPackagesMap[lang])
        dayjs.updateLocale(lang, dayjsLangPackagesMap[lang]);
}

const init = async (lang: string) => {
    const defaultLang = defaultSettings.lang;
    initdayjs(lang)
    return antLangPackagesMap[lang] || antLangPackagesMap[defaultLang]
}

export default init;
